import { createEntityFilesBlock } from "../entity/createEntityFilesBlock.jsx";
import { sanitizeFileUrl } from "../../utils/filePreview.js";
import { buildKundenInlineFiles } from "../../utils/entityInlineFilePresets.js";

const KUNDEN_TYPEN = ["Plan", "Offerte", "Rechnung", "Bestellung", "Protokoll", "Rapport", "E-Mail", "Foto", "Skizze", "Sonstiges"];

function pickSafeUrl(...candidates) {
  for (const candidate of candidates) {
    const safe = sanitizeFileUrl(candidate || "");
    if (safe) return safe;
  }
  return "";
}

const KundenEntityFilesBlock = createEntityFilesBlock({
  title: "📁 Kundendokumente",
  defaultTypes: KUNDEN_TYPEN,
  getApiBase: () => null,
  getApiPaths: (kundenId) => ({
    list: `/kunden/${kundenId}/uploads`,
    create: `/kunden/${kundenId}/upload`,
    remove: (id) => `/kunden/upload/${id}`,
  }),
  parseItems: (data) => {
    const rows = Array.isArray(data) ? data : data?.rows || data?.items || data?.uploads || [];
    return rows;
  },
  resolveFileUrl: (row) => pickSafeUrl(
    row?.secure_preview_url,
    row?.secure_download_url,
    row?.secure_url
  ),
  fileActionMode: "minimal",
  fileActionCompact: true,
  previewModule: "customer_files",
});

export default function KundenBlockUploads({ kundenId }) {
  const scrollId = buildKundenInlineFiles(kundenId)?.scrollTargetId;
  return (
    <div id={scrollId || undefined} className={scrollId ? "scroll-mt-24" : undefined}>
      <KundenEntityFilesBlock entityId={kundenId} />
    </div>
  );
}
